import { render, staticRenderFns } from "./rejectApplyBatch.vue?vue&type=template&id=0a39a542&scoped=true"
import script from "./rejectApplyBatch.vue?vue&type=script&lang=js"
export * from "./rejectApplyBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a39a542",
  null
  
)

export default component.exports